// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2h16s","colCheckbox":"styles_colCheckbox__i6PCq"};